import {neverland as $, render, html, useState, useEffect} from 'neverland';
import { signOut } from '../lib/cognito.js';

const Menu = $(function({auth, setAuth}) {
	
	const [isHidden, setHidden] = useState(false);


	function logout() {
		signOut();
		setAuth(prevAuth => ({
			...prevAuth,
			isLoggedIn: false,
			page: undefined,
			userEmail: null
		}));
		window.history.pushState({}, `Log in`, `/`);
	}

	// function GoToPage(page) {
	// 	return function() {
	// 		window.history.pushState({}, `RY ${page}`, `/${page}/`);
	// 		// setAuth(prevAuth => {
	// 		// 	let auth = {...prevAuth};
	// 		// 	auth.page = page;
	// 		// 	return auth;
	// 		// })
	// 	}
	// }

	const toggleMainMenu = () => {
		setHidden(isHidden => !isHidden);
	}

	const navigateTo = (page) => {
		window.history.pushState({}, `RY ${page}`, `/?p=${page}`);
		setAuth(prevAuth => ({
			...prevAuth,
			page: page
		}));
	}

	return html`
		<div
			id="main-menu-toggle"
			class="main-menu-toggle"
			onclick="${toggleMainMenu}"></div>

		<nav id="main-menu" class="main-menu ${isHidden && 'hide'}">

			<div>

				<strong style="margin-bottom: 10px; display: block;">Collections</strong>

				${auth.isAdmin ? html`
					<button onclick="${() => navigateTo('ClientGroups')}" class="${auth.page == "ClientGroups" ? "here" : null}"><span>
						Client Groups
						</span>
					</button>
					<hr/>
				` : ''}

				<button onclick="${() => navigateTo('Items')}" class="${auth.page == "Items" ? "here" : null}"><span>
					Items
				</span></button>

				<button onclick="${() => navigateTo('ItemSets')}" class="${auth.page == "ItemSets" ? "here" : null}"><span>
					Item Sets
				</span></button>

				<hr/>

				${(auth.isAdmin) ? html`
					<button onclick="${() => navigateTo('Surveys')}" class="${auth.page == "Surveys" ? "here" : null}"><span>
						Surveys
					</span></button>

					<button onclick="${() => navigateTo('Responses')}" class="${auth.page == "Responses" ? "here" : null}"><span>
						Responses
					</span></button>

					<hr/>
				` : ''}
	
				${auth.isAdmin ? html`<button onclick="${() => navigateTo('Themes')}" class="${auth.page == "Themes" ? "here" : null}"><span>
					Themes
				</span></button>` : ''}

				${auth.isAdmin ? html`
					<button onclick="${() => navigateTo('EndScreens')}" class="${auth.page == "EndScreens" ? "here" : null}"><span>
						End Screens
						</span>
					</button>
					<hr/>
				` : ''}

				${auth.isAdmin ? html`
					<button onclick="${() => navigateTo('CSVDownloads')}" class="${auth.page == "CSVDownloads" ? "here" : null}"><span>
						CSV Downloads
						</span>
					</button>
					<hr/>
				` : ''}

				<strong style="margin-bottom: 10px; display: block;">Tools</strong>

				${(auth.isAdmin || auth.isResearcher) ? html`
					<button onclick="${() => navigateTo('CSVCreator')}" class="${auth.page == "CSVCreator" ? "here" : null}"><span>
						CSV Creator
						</span>
					</button>` : ''}

			</div>

			<div>
				<div style="font-size: 0.9em; color: #666; margin-bottom: 5px;">
					Group: ${auth.userGroups.join(', ') || 'user'}
				</div>
				<strong>${auth.userEmail || 'User'}</strong>
				<button onclick="${logout}">
					<span>
						Log out
					</span>
				</button>
			</div>
			

		</nav>`;

});

export default Menu;